import { tv } from 'tailwind-variants'

export const iconBadgeVariants = tv({
  base: [
    'flex items-center justify-center flex-shrink-0',
    'w-[38px] h-[38px]',
    'text-white',
    'shadow-[inset_0_1px_0_rgba(255,255,255,0.6)]',
    [
      'bg-glass-overlay-light relative',
      'before:content-[""] before:absolute before:top-0 before:right-0',
      'before:w-[80%] before:h-[80%] before:rounded-full',
      'before:bg-[radial-gradient(circle,rgba(255,255,255,0.25)_0%,transparent_70%)]',
      'before:mix-blend-plus-lighter before:pointer-events-none'
    ]
  ],
  variants: {
    rounded: {
      true: 'rounded-full',
      false: 'rounded-xl'
    },
    accentColor: {
      none: '',
      yellow: 'bg-yellow-gradient',
      green: 'bg-green-gradient ',
      blue: 'bg-blue-gradient',
      pink: 'bg-pink-gradient'
    }
  },
  defaultVariants: {
    rounded: false
  }
})
